import React from 'react';
import { LogoIcon } from 'components/Icons'

const Logo = () => {
    return (
        <div className="header__logo"><LogoIcon /></div>
    )
}

export default Logo;
